<h2 mat-dialog-title>{{editMode ? "Edit" : "Add"}} Assessment Scores</h2>
<span style="padding: 10px;">
  <student-name [firstName]="selectedStudent.FirstName" [lastName]="selectedStudent.LastName"
    [middleName]="selectedStudent.MiddleName" [nickName]="selectedStudent.NickName"></student-name> - {{masterName}} -
  {{versionName}}
</span>
<mat-dialog-content>
  <div>
    <tyl-datepicker id="testDate" style="width: 200px;" label="Test Date" [(value)]="assessmentDate"
      [(ngModel)]="assessmentDate">
    </tyl-datepicker>

    <tyl-checkbox [disabled]="!userCanMarkScore" id="chkDonotPrintonTranscript" name="chkDonotPrintonTranscript"
      [(checked)]="printOnTranscript" style="padding-right:20px;">Do not
      print on Transcript
    </tyl-checkbox>
  </div>
  <div>
    <table>
      <tr *ngFor="let assField of displayAssessmentFields; let f = index;">
        <td *ngFor="let field of assField" style="padding-right: 20px;">
          <div [ngSwitch]="field.FieldType">

            <!-- Textboxes (Number only) -->
            <tyl-form-field [label]="field.FieldName" [fullWidth]="true" *ngSwitchCase="'2'">
              <input matInput id="inp{{field.FieldName}}" [(ngModel)]="field.FieldData" [allowDecimal]="false"
                [maxPrecision]="0" [minimumEnforce]="0" [maximumEnforce]="field.MaxNumeric"
                [attr.maxlength]="field.Length" />
            </tyl-form-field>

            <!-- Textboxes (Text only)-->
            <tyl-form-field [label]="field.FieldName" [fullWidth]="true" *ngSwitchCase="'0'">
              <input #input matInput id="inp{{field.FieldName}}" type="text" name="{{field.FieldName}}"
                [(ngModel)]="field.FieldData" maxlength="{{field.Length}}" />
            </tyl-form-field>

            <!-- Date -->
            <tyl-datepicker id="inp{{field.FieldName}}" [label]="field.FieldName" [fullWidth]="true" *ngSwitchCase="'1'"
              [(value)]="field.FieldData">
            </tyl-datepicker>

            <!-- Label -->
            <span *ngSwitchCase="'3'"></span>
          </div>
        </td>
      </tr>
    </table>
  </div>

</mat-dialog-content>


<!-- Footer -->
<mat-dialog-actions style="position: sticky">
  <!-- Left -->
  <div class="flex-footer-left">
  </div>
  <!-- Middle -->
  <div class="flex-footer-middle">
  </div>
  <div class="flex-footer-right">
    <!-- <error-prompt [errorList]="errorList"></error-prompt> -->
    <tyl-button image="Save.png" label="Save" (clickEvent)="saveClick()"></tyl-button>
    <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
  </div>
</mat-dialog-actions>